<app-header></app-header>
<!--Breadcrumb-->
        <section>
            <div class="bannerimg cover-image bg-background3" data-image-src="assets/images/banners/banner2.jpg">
                <div class="header-text mb-0">
                    <div class="container">
                        <div class="text-center">
                            <h1 class="">Payments</h1>
                            <!--ol class="breadcrumb text-center">
                                <li class="breadcrumb-item"><a href="home.html">Home</a></li>
                                <li class="breadcrumb-item active text-white">My Dashboard</li>
                                <li class="breadcrumb-item active text-white" aria-current="page">My Preferences</li>
                            </ol-->
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!--Breadcrumb-->

        <!--Section-->
        <section class="sptb">
            <div class="container">
                <div class="row">
                    <div class="col-xl-3 col-lg-12 col-md-12">
                        <!-- my account left menu -->
                <app-my-account-left-menu></app-my-account-left-menu>
                <!-- /my account left menu -->
                    </div>
                    <div class="col-xl-9 col-lg-12 col-md-12">
                        
                        <div class="card mb-0">
                            <div class="card-header  d-sm-flex title-set">
                                <h3 class="card-title col-md-4">Payments</h3>
                                <h3 class="card-title col-md-5">Wallet Balance: <b>{{balance}}</b></h3>
								
								<button class="btn  btn-primary  col-md-3" data-toggle="modal" data-target="#exampleModa23"> Make Payment </button>
							
                            </div>
                            <div class="card-body">
                                <div class="table-responsive border-top">
                                    <table class="table table-bordered table-hover text-nowrap">
                                        <thead>
                                            <tr>
                                                <th>Type</th>                                                
                                                <th>Car Unique Id</th>
                                                <th>Transaction</th>
                                                <th>Amount</th>
                                                <th>Transaction Id</th>                                               
                                                <th>Status</th>
                                                <th>Remark</th>
                                                <th>Date Time</th>                                                
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let transaction of transactionList">
                                                <td>{{transaction.type}}</td>                                                
                                                <td>{{transaction.registration_no}}</td>
                                                <td>{{transaction.transaction_type}}</td>
                                                <td class="font-weight-semibold fs-16">₹{{transaction.amount}}</td>
                                                <td>{{transaction.transaction_id}}</td>
                                                <td>{{transaction.transaction_status}}</td>
                                                <td>{{transaction.remarks}}</td>
                                                <td>{{transaction.created_date_time}}</td>                                                
                                            </tr>
                                            <!-- <tr>
                                                <td>tr-186</td>
                                                <td>Maruti Vitara Brezza</td>
                                                <td>HR 07L 0011</td>
                                                <td>Refund Deposit</td>
                                                <td>Debit</td>
                                                <td class="font-weight-semibold fs-16">₹14,276</td>
                                                <td>14-12-2019 05:50 PM</td>
                                                <td>
                                                    <a class="btn btn-primary btn-sm text-white mb-1" data-toggle="tooltip" data-original-title="View"><i class="fa fa-eye"></i></a>

                                                </td>
                                            </tr>
                                            <tr>
                                                <td>tr-831</td>
                                                <td>Maruti Swift</td>
                                                <td>HR 07A 0022</td>
                                                <td>Purchase Amount</td>
                                                <td>Credit</td>
                                                <td class="font-weight-semibold fs-16">₹25,000</td>
                                                <td>04-12-2019 05:50 PM</td>
                                                <td>
                                                    <a class="btn btn-primary btn-sm text-white mb-1" data-toggle="tooltip" data-original-title="View"><i class="fa fa-eye"></i></a>

                                                </td>
                                            </tr>
                                            <tr>
                                                <td>tr-672</td>
                                                <td>Mahindra Scorpio</td>
                                                <td>HR 07M 1234</td>
                                                <td>Purchase Amount</td>
                                                <td>Credit</td>
                                                <td class="font-weight-semibold fs-16">₹50.00</td>
                                                <td>07-12-2019 05:50 PM</td>
                                                <td>
                                                    <a class="btn btn-primary btn-sm text-white mb-1" data-toggle="tooltip" data-original-title="View"><i class="fa fa-eye"></i></a>

                                                </td>
                                            </tr>
                                            <tr>
                                                <td>tr-428</td>
                                                <td>Hyundai Elite i20</td>
                                                <td>HR 07V 3453</td>
                                                <td>Purchase Amount</td>
                                                <td>Credit</td>
                                                <td class="font-weight-semibold fs-16">₹99.99</td>
                                                <td>11-12-2019 05:50 PM</td>
                                                <td>
                                                    <a class="btn btn-primary btn-sm text-white mb-1" data-toggle="tooltip" data-original-title="View"><i class="fa fa-eye"></i></a>

                                                </td>
                                            </tr>
                                            <tr>
                                                <td>tr-543</td>
                                                <td>Tata Altroz</td>
                                                <td>HR 22M 4546</td>
                                                <td>Deposit Topup</td>
                                                <td>Debit</td>
                                                <td class="font-weight-semibold fs-16">₹145</td>
                                                <td>12-12-2019 05:50 PM</td>
                                                <td>
                                                    <a class="btn btn-primary btn-sm text-white mb-1" data-toggle="tooltip" data-original-title="View"><i class="fa fa-eye"></i></a>

                                                </td>
                                            </tr>
                                            <tr>
                                                <td>tr-986</td>
                                                <td>Hyundai Venue</td>
                                                <td>HR 03M 2324</td>
                                                <td>Deposit Topup</td>
                                                <td>Debit</td>
                                                <td class="font-weight-semibold fs-16">₹378</td>
                                                <td>07-12-2019 05:50 PM</td>
                                                <td>
                                                    <a class="btn btn-primary btn-sm text-white mb-1" data-toggle="tooltip" data-original-title="View"><i class="fa fa-eye"></i></a>

                                                </td>
                                            </tr>
                                            <tr>
                                                <td>tr-867</td>
                                                <td>Maruti Baleno</td>
                                                <td>HR 02M 3536</td>
                                                <td>Deposit Topup</td>
                                                <td>Debit</td>
                                                <td class="font-weight-semibold fs-16">₹509.00</td>
                                                <td>06-12-2019 05:50 PM</td>
                                                <td>
                                                    <a class="btn btn-primary btn-sm text-white mb-1" data-toggle="tooltip" data-original-title="View"><i class="fa fa-eye"></i></a>

                                                </td>
                                            </tr>
                                            <tr>
                                                <td>tr-893</td>
                                                <td>Toyota Fortuner</td>
                                                <td>HR 03M 5070</td>
                                                <td>Deposit Topup</td>
                                                <td>Debit</td>
                                                <td class="font-weight-semibold fs-16">₹347</td>
                                                <td>30-11-2019 05:50 PM</td>
                                                <td>
                                                    <a class="btn btn-primary btn-sm text-white mb-1" data-toggle="tooltip" data-original-title="View"><i class="fa fa-eye"></i></a>

                                                </td>
                                            </tr>
                                            <tr>
                                                <td>tr-267</td>
                                                <td>Hyundai Creta</td>
                                                <td>HR 10K 5555</td>
                                                <td>Purchase Amount</td>
                                                <td>Credit</td>
                                                <td class="font-weight-semibold fs-16">₹895</td>
                                                <td>27-11-2019 05:50 PM</td>
                                                <td>
                                                    <a class="btn btn-primary btn-sm text-white mb-1" data-toggle="tooltip" data-original-title="View"><i class="fa fa-eye"></i></a>

                                                </td>
                                            </tr>
                                            <tr>
                                                <td>tr-931</td>
                                                <td>Renault Triber</td>
                                                <td>HR 56M 4546</td>
                                                <td>Purchase Amount</td>
                                                <td>Credit</td>
                                                <td class="font-weight-semibold fs-16">₹765</td>
                                                <td>25-12-2019 05:50 PM</td>
                                                <td>
                                                    <a class="btn btn-primary btn-sm text-white mb-1" data-toggle="tooltip" data-original-title="View"><i class="fa fa-eye"></i></a>

                                                </td>
                                            </tr> -->
                                        </tbody>
                                    </table>
                                </div>
                                <!-- <ul class="pagination">
                                    <li class="page-item page-prev disabled">
                                        <a class="page-link"  tabindex="-1">Prev</a>
                                    </li>
                                    <li class="page-item active"><a class="page-link" >1</a></li>
                                    <li class="page-item"><a class="page-link" >2</a></li>
                                    <li class="page-item"><a class="page-link" >3</a></li>
                                    <li class="page-item page-next">
                                        <a class="page-link" >Next</a>
                                    </li>
                                </ul> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
               
                 
    </section>
    <!--/Section-->

    <div class="modal fade" id="exampleModa23" tabindex="-1" role="dialog"  aria-hidden="true">
        
				  <div class="modal-dialog" role="document">
					<div class="modal-content">
                    <form [formGroup]="paymentFormGroup"> 
					<div class="col-md-12 d-flex pt-3">
					 <div class="form-group col-md-6">
                                            
							<label class="custom-control custom-radio click-rediotop" >
								<input type="radio" formControlName="paymentType" class="custom-control-input" name="paymentType" value="topup" checked>
								<span class="custom-control-label">Topup my account</span>                                                
							</label>   
						</div>
						<div class="form-group col-md-6" style="display:none;">
							<label class="custom-control custom-radio click-rediopur">
								<input type="radio"  formControlName="paymentType" class="custom-control-input" name="paymentType" value="payment">
								<span class="custom-control-label">Deposit for Purchase</span>
							</label>   
						</div> 
						</div> 
						
						<div class="col-md-12  pt-3 topupmy ">
										<div class="form-group col-md-12">
                                          <label for="inputEmail4" class="form-label">Enter Amount</label>
                                          <input type="number"  formControlName="paymentWalletAmount" class="form-control" id="inputEmail5" placeholder="Enter Amount">
                                            <div *ngIf="paymentFormGroup.get('paymentWalletAmount').errors  && isSubmitPayment">  
                                            <div *ngIf="paymentFormGroup.get('paymentWalletAmount').hasError('required')">  
                                                <span style="color: red;">Enter amount</span>  
                                            </div>
                                            </div> 
                                        </div>
										<div class="form-group col-md-12">
                                          <label for="inputEmail4" class="form-label">Remarks  </label>
                                          <textarea rows="4" cols="4" formControlName="paymentWalletRemark" class="form-control" id="inputEmail5" placeholder="Remarks  "></textarea>
                                          <div *ngIf="paymentFormGroup.get('paymentWalletRemark').errors  && isSubmitPayment">  
                                          <div *ngIf="paymentFormGroup.get('paymentWalletRemark').hasError('required')">  
                                                <span style="color: red;">Enter Remarks</span>  
                                          </div>
                                          </div> 
                                        </div>
										<div class=" col-sm-12 col-md-12  mb-3">
                                      <button type="button" class="btn btn-primary text-white" *ngIf="paymentBTNLabel=='Pay'" (click)="proceedPaymentRequest(paymentFormGroup.value)">{{paymentBTNLabel}}</button>
                                      <button type="button" class="btn btn-primary text-white" *ngIf="paymentBTNLabel!='Pay'">{{paymentBTNLabel}}</button>
                                    </div>
						</div>
									<div class="col-md-12  pt-3 depoitfor  common-none">
										<div class="form-group col-md-12">
                                            <label for="inputEmail4" class="form-label"> Select Car Reg No</label>
                                                <select class="form-control w-100 select2-show-search" data-placeholder="Select">
                                                <optgroup label="Select Car">
                                                    <option value="">--Select--</option>
                                                    <!-- <option value="1">PB 10 2398 </option>
                                                    <option value="2">CH 01 0022</option> -->
                                                </optgroup>
                                            </select>
                                            <div>  
                                            <div>  
                                                <span style="color: red;">Select Car</span>  
                                            </div>
                                            </div>
                                        </div>                                        
										<div class="form-group col-md-12">
                                          <label for="inputEmail4" class="form-label"></label>
                                          
                                        </div>
										<div class="form-group col-md-12">
                                          <label for="inputEmail4" class="form-label">Enter Amount</label>
                                          <input type="number" class="form-control" id="inputEmail5" placeholder="Enter Amount">
                                        </div>
										<div class="form-group col-md-12">
                                          <label for="inputEmail4" class="form-label">Remarks  </label>
                                          <textarea rows="4" cols="4" class="form-control" id="inputEmail5" placeholder="Remarks  "></textarea>
                                        </div>
										<div class=" col-sm-12 col-md-12 mb-3">
                                      <button type="submit" class="btn btn-primary text-white">Pay</button>
                                    </div>
					</div>							
						
						
					</form>	
					</div>
				  </div>
                
			</div>
<app-footer></app-footer>
